export const environment = {
  production: true,
  hmr: false,
  apiUrl: "https://api.staging.goalngo.com",
  stageingDomain: "https://api.staging.goalngo.com",

  authApi: "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword",

  authKey: "AIzaSyDXjPvoFeMGj-lfZNnhbHtXvg3y2HbECA8",
  // production URL
  productionAuthUrl: "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword",
  productionAuthKey: "AIzaSyAIOEvvedn33iU9ulQdoqo95_qReW2iOEQ",
  // productionAuthKey: "AIzaSyAIOEvvedn33iU9ulQdoqo95_qReW2iOEQ",
  mediaStagingFetching: "https://cdn.staging.goalngo.com",
  mediaProductionFetching: "https://cdn.app.goalngo.com",
  productionDomain: "https://api.staging.goalngo.com",
  appVersion: "1.0.0",
  forceStorageReset: false,
};
